<template>
  <div class="outcome-stats shadow-1">
      <div class="qrw-heading-xs bold v1-grey-10-color">
          {{ $t('balance_table.outcome_stats') }}
      </div>
      <OutcomeStatsGraph :dataset="dataset" height="50" v-if="stats"/>
  </div>
</template>

<script>
import BillingAPI from "@/api/billing"

import OutcomeStatsGraph from "@/components/balance/OutcomeStatsGraph.vue"

import moment from 'moment'

export default {
    data() {
        return {
            stats: null
        }
    },
    mounted() {
        BillingAPI.getOutcomeStats().then(data => {
            this.stats = data.stats;
        });
    },
    computed: {
        dataset() {
            if (!this.stats) return [];

            const keys = {};

            let pvt = moment().subtract(2, 'week');

            while (pvt.isBefore(moment())) {
                const k = pvt.format('YYYY-MM-DD');

               keys[k] = 0;

                pvt = pvt.add(1, 'day');
            }

            for (const stat of this.stats) {
                keys[stat._id] = Math.round(stat.sum * 100) / 100;
            }
           
            const result = {};

            for (const k in keys) {
                const date = moment(k, 'YYYY-MM-DD');

                result[date.format('MMM D, YYYY')] = Math.abs(keys[k]);
            }

            return Object.entries(result).map(e => e);
        }
    },
    components: {
        OutcomeStatsGraph
    }
}
</script>

<style scoped>
.outcome-stats {
    padding: 16px;
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    background: var(--v1-grey-2-color);
    border-radius: 8px;
    height: 100%;
}
</style>